import React, { useState } from 'react';
import {
  ChakraProvider,
  Box,
  Text,
  VStack,
  Grid,
  theme,
  // HStack,
  // Switch,
} from '@chakra-ui/react';
import ShopifyPricingTable from './Components/ShopifyPricingTable';
import { InputDataStore } from './Components/InputDataStore';
import { UsingShopifyPayment } from './Components/UsingShopifyPayment';

const App = () => {
  const [input, setInput] = useState({
    typePaymentGateway: 'shopify',
    orderPerMonth: 10,
    avgOrderValue: 100,
    isPlanYearly: true,
    externalPaymentPercent: 2,
    externalPaymentMoney: 0.2,
    isShowShopifyPlus: false,
  });
  const handleChangeInput = (key, value) => {
    setInput(prev => ({
      ...prev,
      [key]: value,
    }));
  };

  const shopifyPlanPricing = [
    {
      id: 'basic',
      name: 'Basic Plan',
      priceMonthly: 39,
      priceYearly: 29,
      shopifyPaymentRate: 0.029,
      transactionFee: 0.02,
      url: 'https://shopify.pxf.io/Vm46d3',
    },
    {
      id: 'shopify',
      name: 'Shopify Plan',
      priceMonthly: 105,
      priceYearly: 79,
      shopifyPaymentRate: 0.026,
      transactionFee: 0.01,
      url: 'https://shopify.pxf.io/JzqmZa',
    },
    {
      id: 'advanced',
      name: 'Advanced Plan',
      priceMonthly: 399,
      priceYearly: 299,
      shopifyPaymentRate: 0.024,
      transactionFee: 0.005,
      url: 'https://shopify.pxf.io/WqYGEM',
    },
    {
      id: 'basic',
      name: 'Shopify Plus',
      priceMonthly: 2000,
      priceYearly: 2000,
      shopifyPaymentRate: 0.015,
      transactionFee: 0.0015,
    },
  ];

  const calculatorPaymentFees = ({
    price,
    isGateWayShopify,
    input,
    shopifyPaymentPlan,
  }) => {
    let creditCardRate;
    let totalCost;
    let transactionFees = 0;

    if (isGateWayShopify) {
      creditCardRate =
        input.avgOrderValue *
          shopifyPaymentPlan.shopifyPaymentRate *
          input.orderPerMonth +
        0.3 * input.orderPerMonth;
      totalCost = creditCardRate + price;
      return {
        creditCardRate,
        totalCost,
        transactionFees,
      };
    }
    creditCardRate =
      (input.avgOrderValue *
        input.externalPaymentPercent *
        input.orderPerMonth) /
        100 +
      input.externalPaymentMoney * input.orderPerMonth;
    transactionFees =
      input.avgOrderValue *
      input.orderPerMonth *
      shopifyPaymentPlan.transactionFee;
    totalCost = creditCardRate + price + transactionFees;
    return {
      creditCardRate,
      totalCost,
      transactionFees,
    };
  };

  return (
    <ChakraProvider theme={theme}>
      <Box textAlign="center" fontSize="xl" mt={7}>
        <Grid p={3}>
          <VStack spacing={8} title={''}>
            <InputDataStore
              input={input}
              handleChangeInput={handleChangeInput}
            />
            <UsingShopifyPayment
              input={input}
              handleChangeInput={handleChangeInput}
            />
            {/* <HStack>*/}
            {/*  <Text fontSize={'sm'}>Show Shopify Plus Plan</Text>*/}
            {/*  <Switch*/}
            {/*    isChecked={input.isShowShopifyPlus}*/}
            {/*    size="sm"*/}
            {/*    onChange={e =>*/}
            {/*      handleChangeInput('isShowShopifyPlus', e.target.checked)*/}
            {/*    }*/}
            {/*  />*/}
            {/* </HStack>*/}
            <ShopifyPricingTable
              {...{
                input,
                handleChangeInput,
                shopifyPlanPricing,
                calculatorPaymentFees,
              }}
            />
            <Text as="samp">From Avada With Love</Text>
          </VStack>
        </Grid>
      </Box>
    </ChakraProvider>
  );
};

export default App;
